// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060305/js/" + chunkId + "." + {"44":"5d570048","225":"af64181c","481":"045a7a09","486":"15956f85","770":"ae582c56"}[chunkId] + ".0.9995183504939902.chunk.js";
};